
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/articles/[id]",
      function () {
        return require("private-next-pages/hotels/articles/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotels/articles/[id]"])
      });
    }
  